/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Yummy_Smug_Ocelot_RiseInputs */

const fr_yummy_smug_ocelot_rise = /** @type {(inputs: Yummy_Smug_Ocelot_RiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

/**

* @param {Yummy_Smug_Ocelot_RiseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const yummy_smug_ocelot_rise = /** @type {((inputs?: Yummy_Smug_Ocelot_RiseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Yummy_Smug_Ocelot_RiseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_yummy_smug_ocelot_rise(inputs)
});